/* eslint-disable react-hooks/exhaustive-deps */
import { Path, StoreKey } from "@common/constans";
import { StorageType } from "@common/enum";
import Storage from "@service/Storage";
import { useEffect, useMemo } from "react";
import { FC, useReducer } from "react"
import { Route, Switch, useHistory, useLocation } from "react-router";
import { Feedback } from "./Feedback";
import { reducer, ParticipateContext, Welcome, Questionnaire } from "./index";

export const FlightSurvey: FC = () => {
    const { push } = useHistory();
    const { pathname } = useLocation();
    const [participate, participateDispatch] = useReducer(reducer, {});

    useEffect(() => {
        if (pathname !== Path.FlightSurvey.Start)
            push(Storage.get(StoreKey.SearchHistory, StorageType.Session));
    }, []);

    useEffect(() => {
    }, [pathname]);

    return (
        <ParticipateContext.Provider
            value={useMemo(() => { return { participate, participateDispatch } }, [participate, participateDispatch])}
        >
            <div className="flight-survey">
                <div className="container">
                    <Switch>
                        <Route path={Path.FlightSurvey.Start} exact>
                            <Welcome />
                        </Route>
                        <Route path={Path.FlightSurvey.Questionnaire}>
                            <Questionnaire />
                        </Route>
                        <Route path={Path.FlightSurvey.Feedback}>
                            <Feedback />
                        </Route>
                    </Switch>
                </div>
            </div>
        </ParticipateContext.Provider>
    )
}